<template>
  <!-- 抽签活动 -->
  <div class="page" v-if="detail.progress">
    <navigation
      :theme="{
        background: '#FF641F',
        color: '#fff',
      }"
      arrTheme="white"
      :sticky="false"
    >
      <span>周三添财日</span>
      <span slot="right" class="rule-txt" @click="jumpRule">活动规则</span>
    </navigation>
    <particle class="bg-particle"></particle>
    <!-- header -->
    <div class="header">
      <div class="today-step">
        今日 <span>{{detail.userNum}}</span> 位用户已集齐5色宝石，高通卡库存进度<span>{{detail.progress}}%</span>
      </div>
      <div class="header-title"><img src="./images/title@2x.png" /></div>

      <div class="end-time">
        <span>距离活动结束仅剩</span>
        <van-count-down :time="countDownTime">
          <template #default="timeData">
            <span class="block">{{ timeData.hours }}</span>
            <span class="colon">小时</span>
            <span class="block">{{ timeData.minutes }}</span>
            <span class="colon">分</span>
          </template>
        </van-count-down>
      </div>
    </div>
    <img src="./images/img_yinying@2x.png" class="bg2" :class="{notUse:['NOT_USE','USED'].includes(detail.activeRecordStatus) }">
    <!-- 未集齐 -->
    <div 
      class="turntable-container" 
      v-if="(!detail.activeRecordStatus || detail.activeRecordStatus==='TO_BE_START') && (!detail.gemsList || detail.gemsList.length!==5)"
      data-sensors-exposure-event-name="Element_Exposure"  
      data-sensors-exposure-property-caseId="TO_BE_START"
    >
      <div class="turntable-bottom">
        <img
          src="./images/img_zhuanpan02@2x.png"
          class="turntable"
          :class="{animation}"
          :style="`transform: rotate(${rotate}deg)`"
        />
        <img src="./images/img_zhuanpan01@2x.png" class="point" />
      </div>
      <div class="btn-box" @click="handleDrawGems" data-sensors-click>
        <span>召唤5色宝石</span>
        <img src="./images/img_arrow@2x.png" />
      </div>
    </div>

  
    <!-- 已集齐 未兑换 -->
    <div class="wait-start" v-if="detail.gemsList && detail.gemsList.length===5 && detail.activeRecordStatus==='TO_BE_START' ">
      <img 
        src="./images/img_jiqi@2x.png" 
        class="gems-img" 
        data-sensors-exposure-event-name="Element_Exposure"  
        data-sensors-exposure-property-caseId="receiveActive"
      >
      <div class="btn-box" @click="lockQuota" data-sensors-click >
        <span>兑换提现高通卡</span>
        <img src="./images/img_arrow@2x.png" />
      </div>
      <div class="tips">通过率高达99.8%</div>
    </div>

    <!-- 已兑换 未使用 -->
    <div 
      class="wait-start not-use" 
      data-sensors-exposure-event-name="Element_Exposure"  
      data-sensors-exposure-property-caseId="NOT_USE"
      v-if="detail.activeRecordStatus==='NOT_USE'"
    >
      <img src="./images/img_yiduihuan@2x.png" class="gems-img" >
      <div class="btn-box" @click="withdraw" data-sensors-click>
        <span>立即提现</span>
        <img src="./images/img_arrow@2x.png" />
      </div>
      <div class="tips">仅限今日使用有效</div>
    </div>

    <!-- 已使用 -->
    <div 
      class="wait-start used" v-if="detail.activeRecordStatus==='USED'"
      data-sensors-exposure-event-name="Element_Exposure"  
      data-sensors-exposure-property-caseId="USED"
    >
      <img src="./images/img_yiduihuan@2x.png" class="gems-img" >
      <div class="btn-box"  data-sensors-click>
        <span>您已参与今日活动</span>
      </div>
    </div>

    <div class="bag-container" v-if="detail.activeRecordStatus !== 'USED'">
      <div class="bag-header">
        <img src="./images/img_a@2x.png" />
        <span>我收集的宝石</span>
        <img src="./images/img_b@2x.png" />
      </div>
      <div class="bag-content">
        <p>
          集齐5色宝石即可兑换一张提现高通卡，通过率高达99.8%。今日提现使用有效，先到先得，提钱享受
        </p>
        <div class="bag-detail">
          <i class="RUBY" v-show="hasgems('RUBY')">红宝石</i>
          <i class="TOPAZ" v-show="hasgems('TOPAZ')">黄宝石</i>
          <i class="SAPPHIRE" v-show="hasgems('SAPPHIRE')">蓝宝石</i>
          <i class="EMERALD" v-show="hasgems('EMERALD')">绿宝石</i>
          <i class="AMETHYST" v-show="hasgems('AMETHYST')">紫水晶</i>
        </div>
      </div>
    </div>

    <withdraw-user-flipper
      v-if="detail.rollingData && detail.rollingData.length"
      :background="'linear-gradient( 270deg, #FFD8A3 0%, #FFB76A 100%)'"
      :amountTextColor="'#FF4633'"
      :users="detail.rollingData"
    />

    <img src="./images/img_haoyunbaoshi@2x.png" class="footer-img" />

    <!-- 弹窗 -->
    <div
      class="dialog-result"
      v-if="showDialog"
      :class="{ dropdown, showDialog }"
    >
      <i class="mask"></i>
      <div 
        class="content-container gems-container"   
        v-if="dialogType === 'GEMS'" 
        data-sensors-exposure-event-name="PopupDisplay"  
        :data-sensors-exposure-property-caseId="`GEMS_${gems}`"
      >
        <img src="./images/title_2@2x.png" class="title" />
        <div class="light-container"><img src="./images/img_guang@2x.png" class="light" /></div>
        <img :src="gemsImage" class="gems-img" />
        <p>{{ gems | gemsName }} x1</p>
        <div class="btn-box handleDropdown" data-sensors-click @click="handleDropdown">
          立即收下
        </div>
        <img
          src="../images/btn_close@2x.png"
          class="dialog-close"
          data-sensors-click
          @click="handleDropdown"
        />
      </div>
      

      <div 
        class="content-container card-container" v-else  data-sensors-exposure-event-name="PopupDisplay"  
        :data-sensors-exposure-property-caseId="`CARD`"
      >
        <img src="./images/title_3@2x.png" class="title" />
        <div class="light-container"> <img src="./images/img_guang@2x.png" class="light" /></div>
        <img src="./images/pop_gaotong@2x.png" class="gems-img" />
        <p>限今日提现，通过率99.8%</p>
        <div class="btn-box" data-sensors-click @click="withdraw">立即提现</div>
        <img
          src="../images/btn_close@2x.png"
          class="dialog-close"
          data-sensors-click
          @click="showDialog = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import withdrawUserFlipper from '../components/withdraw-user-flipper.vue'
import Card from '../components/card.vue'
import particle from '../components/particle'
import { mapActions } from 'vuex'
import AMETHYST from './images/pop_zi@2x.png'
import EMERALD from './images/pop_lu@2x.png'
import SAPPHIRE from './images/pop_lan@2x.png'
import TOPAZ from './images/pop_huang@2x.png'
import RUBY from './images/pop_hong@2x.png'
export default {
  components: {
    withdrawUserFlipper,
    Card,
    particle
  },
  data () {
    return {
      showDialog: false,
      detail: {
        residue: 0,
        rollingData: []
      },
      animation: false,
      cardList: [1, 2, 3, 4, 5, 6],
      showBack: false,
      pendding: false,
      assemble: false,
      activeItem: null,
      type: 'RAISE_1000',
      rotate: 0,
      gems: '',
      dialogType: 'GEMS',
      gemsList: {
        AMETHYST,
        EMERALD,
        SAPPHIRE,
        TOPAZ,
        RUBY
      },
      drawPending: false,
      dropdown: false
    }
  },
  filters: {
    gemsName (value) {
      const gems = {
        EMERALD: '绿宝石',
        AMETHYST: '紫水晶',
        RUBY: '红宝石',
        TOPAZ: '黄宝石',
        SAPPHIRE: '蓝宝石'
      }
      return gems[value]
    }
  },
  mounted () {
    this.getDetail()
    this.$bus.$emit('ready')
  },
  computed: {
    gemsImage () {
      return this.gemsList[this.gems]
    },
    countDownTime () {
      // 获取当前时间戳
      const now = new Date().getTime()
      return this.detail.residue - now
    }
  },
  methods: {
    ...mapActions('activities', ['getActivityDetail', 'receiveActive', 'drawGems']),
    handleGetGems (gemsType) {
      this.animation = true
      const rotate = {
        EMERALD: 0,
        AMETHYST: 1,
        RUBY: 2,
        TOPAZ: 3,
        SAPPHIRE: 4
      }
      this.rotate = 3 * 360 + 72 * rotate[gemsType] + 36

      // 打开弹窗
      setTimeout(() => {
        this.showDialog = true
        this.drawPending = false
        setTimeout(() => {
          this.animation = false
          this.rotate = 0
        }, 500)
      }, 5000)
    },

    hasgems (type) {
      return this.detail.gemsList?.some(item => item.gems === type)
    },

    jumpRule () {
      this.$router.push({
        path: '/act-three-rules'
      })
    },
    // 抽宝石
    async handleDrawGems () {
      if (this.drawPending) return
      this.drawPending = true
      const { success, data } = await this.drawGems({
        activeCode: 'ACTIVE_BOX',
        subCode: 'ACTIVE_BOX_LUCK_GEMS'
      })
      if (success) {
        this.gems = data        
        this.handleGetGems(data)
      }
    },

    handleDropdown () {
      this.dropdown = true
      setTimeout(() => {
        this.dropdown = false
        this.showDialog = false
        this.getDetail()
      }, 1500)
    },
    // 领取
    async lockQuota () {
      if (window.pending) return
      window.pending = true
      const { success } = await this.receiveActive({
        activeCode: 'ACTIVE_BOX',
        subCode: 'ACTIVE_BOX_LUCK_GEMS'
      })
      window.pending = false
      this.getDetail()
      if (success) {
        this.showDialog = true
      }
    },
    // 获取活动详情
    async getDetail () {
      const { success, data } = await this.getActivityDetail({
        activeCode: 'ACTIVE_BOX',
        subCode: 'ACTIVE_BOX_LUCK_GEMS'
      })
      if (success) {
        this.detail = data || {}
        if (this.detail.gemsList?.length === 5) {
          this.dialogType = 'CARD'
        }
      } else {
        setTimeout(() => {
          this.$router.push('/')
        }, 2000)
      }
    },
    // 提现
    withdraw () {
      this.$router.push('/middle/limit')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.page {
  width: 10rem;
  overflow: hidden;
  background: linear-gradient(
    180deg,
    #ff641f 0%,
    #ff641f 10%,
    #ffe7bc 56%,
    #fff6dc 100%
  );
  min-height: 100vh;
  padding-bottom: 40px;
  .bg-particle {
    height: 1000px;
    top:200px;
    width: 100%;
    overflow: hidden;
  }
  .bg2 {
    position: absolute;
    width: 100%;
    top:1100px;
    &.notUse {
      top:1150px
    }
  }
  .wait-start {
    position: relative;
    height: 820px;
    &.not-use {
      height: 870px;
    }
    &.used {
      height: 870px;
      .btn-box{
        background-image: url('./images/btn_yicanyu@2x.png')
      }
    }
    .gems-img {
      width: 750px;
      margin: 25PX auto 0;
      display: block;
    }
    .tips {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 23px;
      color: #9D3F08;
      line-height: 32px;
      text-align: center;
      height: 40px;
      padding:0 20px;
      line-height: 40px;;
      background: linear-gradient( 270deg, #FFE671 0%, #FBFF71 100%);
      border-radius: 21px 21px 21px 0px;
      position: relative;
      left:52%;
      bottom:100px;
      position: absolute;
    }
    .btn-box {
      position: absolute;
      bottom: 0;
      width: 567px;
      height: 121px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url("./images/btn@2x.png") no-repeat;
      background-size: 100% 100%;
      left: 50%;
      transform: translateX(-50%);
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 42px;
        color: #ffffff;
        line-height: 59px;
      }
      img {
        margin-left: 10px;
        width: 38px;
        animation: move 0.5s infinite alternate;
      }
      @keyframes move {
        to {
          transform: translateX(10px);
        }
      }
    }
  }
  .dialog-result {
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    z-index: 9999;
    .dialog-close {
      position: relative;
      width: 60px;
      margin: 100px auto;
      opacity: 0;
    }
    &.showDialog {
      .title {
        animation: fallDown 0.5s 0.6s forwards;
      }
      .light-container {
        animation: fallDown 0.5s 0.4s forwards;
      }
      .gems-img {
        animation: fallDown 0.5s 0.4s forwards;
      }
      p {
        animation: fallDown 0.5s 0.3s forwards;
      }
      .btn-box {
        animation: fallDown 0.5s 0.2s forwards;
      }
      .dialog-close {
        animation: fallDown 0.5s 0.1s forwards;
      }
    }
    @keyframes fallDown {
      0% {
        transform: translateY(-800px);
        opacity: 0.5;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
    &.dropdown {
      .gems-img {
        animation: dropdown 1s cubic-bezier(0.64, -0.79, 0.39, 1.43) forwards;
      }
      .mask,
      .light,
      .btn-box,
      p,
      .title,
      .dialog-close {
        animation: hidden 0.5s forwards !important;
      }
      @keyframes hidden {
        to {
          opacity: 0;
        }
      }
    }
    @keyframes dropdown {
      0% {
        transform: translateY(-100px) scale(1.1) translateX(100px);
        opacity: 1;
      }
      100% {
        transform: translateY(1000px) translateX(-100px) scale(0.2);
        opacity: 0;
      }
    }

    i.mask {
      background: rgba(0, 0, 0, 0.7);
      height: 100vh;
      width: 100vw;
      position: absolute;
      top: 0;
      left: 0;
    }
    .content-container {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      display: flex;
      justify-content: center;
      flex-direction: column;
      .light {
        animation: rotateLight 5s infinite linear;
        height: 440px;
        width: 440px;
        position: absolute;
        left: 50%;
        top: 60px;
        transform: translateX(-50%);
       
      }
      .light-container {
        opacity: 0;
        height: 440px;
        width: 440px;
        position: absolute;
        left:0; top:0;
        
      }
      @keyframes rotateLight {
        to {
          transform: translateX(-50%) rotateZ(360deg);;
        }
      }
      .btn-box {
        width: 480px;
        height: 100px;
        background: url("./images/btn@2x.png") no-repeat;
        background-size: 100% 100%;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 42px;
        color: #ffffff;
        line-height: 100px;
        text-align: center;
        margin-top: 60px;
        opacity: 0;
      }
    }
    .card-container {
      .title {
        height: 47px;
        width: 446px;
        margin: auto;
        opacity: 0;
      }

      .gems-img {
        width: 290px;
        height: 263px;
        margin: 100px auto 0;
        position: relative;
        transition: all 0.5s;
        opacity: 0;
      }
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 32px;
        color: #ffffff;
        line-height: 45px;
        text-align: center;
        margin-top: 30px;
        opacity: 0;
      }
    }
    .gems-container {
      .title {
        height: 47px;
        width: 396px;
        margin: auto;
        opacity: 0;
      }

      .gems-img {
        width: 233px;
        height: 233px;
        margin: 100px auto 0;
        position: relative;
        transition: all 0.5s;
        opacity: 0;
      }
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 32px;
        color: #ffffff;
        line-height: 45px;
        text-align: center;
        margin-top: 30px;
        opacity: 0;
      }
    }
  }
  .bag-container {
    width: 650px;
    margin: 65px auto 50px;
    position: relative;
    .bag-header {
      width: 650px;
      height: 100px;
      background: linear-gradient(270deg, #ffb76a 0%, #ffd8a3 100%);
      border-radius: 30px 30px 0px 0px;
      display: flex;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #8c3821;
      justify-content: center;
      column-gap: 40px;
      padding-bottom: 20px;
      align-items: center;
      img {
        width: 149px;
        height: 18px;
      }
    }
    .bag-content {
      background: #fff;
      padding: 40px;
      border-radius: 30px;
      margin-top: -20px;
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #666666;
        line-height: 33px;
      }
      .bag-detail {
        width: 483px;
        height: 260px;
        background: url("./images/img_pintu@2x.png") no-repeat;
        background-size: 100% 100%;
        margin: 27px auto 0;
        position: relative;
        i {
          position: absolute;
          width: 100%;
          height: 100%;
          background-size: 100% 100% !important;
          font-size: 0;
        }
        .RUBY {
          background: url("./images/1.png") no-repeat;
        }
        .TOPAZ {
          background: url("./images/2.png") no-repeat;
        }
        .SAPPHIRE {
          background: url("./images/3.png") no-repeat;
        }
        .EMERALD {
          background: url("./images/4.png") no-repeat;
        }
        .AMETHYST {
          background: url("./images/5.png") no-repeat;
        }
      }
    }
  }

  .turntable-container {
    position: relative;
    height: 850px;
    .turntable {
      position: absolute;
      width: 720px;
      height: 720px;
      left: 15px;
      &.animation {
        transition: transform 5s;
      }
    }
    .point {
      position: absolute;
      width: 210px;
      height: 210px;
      left: 50%;
      top: 255px;
      transform: translateX(-50%);
    }
    .turntable-bottom {
      position: relative;
      background: url(./images/img_dibu@2x.png) no-repeat center bottom;
      background-size: 299px 95px;
      height: 740px;
    }
    .btn-box {
      position: absolute;
      bottom: 0;
      width: 567px;
      height: 121px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url("./images/btn@2x.png") no-repeat;
      background-size: 100% 100%;
      left: 50%;
      transform: translateX(-50%);
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 42px;
        color: #ffffff;
        line-height: 59px;
      }
      img {
        margin-left: 10px;
        width: 38px;
        animation: move 0.5s infinite alternate;
      }
      @keyframes move {
        to {
          transform: translateX(10px);
        }
      }
    }
  }

  .footer-img {
    width: 302px;
    display: block;
    margin: 66px auto;
    position: relative
  }

  .rule-txt {
    font-family: PingFangSC, PingFang SC;
    font-size: 28px;
    color: #ffffff;
    line-height: 40px;
    text-align: right;
    font-style: normal;
    margin-right: 40px;
    display: block;
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .today-step {
      font-size: 24px;
      color: #ffffff;
      line-height: 37px;
      text-align: center;
      margin-top: 40px;
      background: #e55312;
      width: 650px;
      padding: 11px;
      border-radius: 10px;
      span {
        color: #ffdc54;
      }
    }
    .header-title {
      margin-top: 40px;
      img {
        width: 582px;
      }
    }
    .end-time {
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      color: #ffffff;
      line-height: 37px;
      display: flex;
      justify-content: center;
      margin-top: 17px;
      .van-count-down {
        display: flex;
        align-items: center;
        .block {
          color: #ff4633;
          background-color: #ffd9d9;
          border-radius: 4px;
          font-size: 26px;
          width: 36px;
          height: 36px;
          line-height: 36px;
          margin-left: 9px;
          margin-right: 9px;
          text-align: center;
          display: block;
        }
        .colon {
          color: #fff;
          font-size: 26px;
        }
      }
    }
  }
}
</style>
